<div class="loading-wrapper">
  <img src="assets/gif/blue_bg.gif" class="loading-gif" />
</div>